import React from 'react';
import { Mail } from 'lucide-react';

export default function Contact() {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto space-y-16">
        {/* Hero Section */}
        <div className="text-center space-y-4">
          <h1 className="text-3xl md:text-4xl font-bold text-white">
            İletişim
          </h1>
          <p className="text-gray-400 text-lg">
            Bize e-mail bırakın
          </p>
        </div>

        {/* Contact Info */}
        <div className="max-w-lg mx-auto">
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-white/5">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
                <Mail className="w-6 h-6 text-gray-900" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-white">E-posta</h2>
                <a 
                  href="mailto:info@enyakintaksi.app" 
                  className="text-gray-400 hover:text-yellow-400 transition-colors"
                >
                  info@enyakintaksi.app
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}